import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiTextField, MuiButton, Message, AccordionWithArrow } from '../../../../components'
// import { CONST_PASSWORD_USER_MANAGEMENT_ACCESS } from '../../../../constants'
// import userManagement from '../../../../services/userManagement.service'
import { validateLocalPassword } from '../../../../util'
import { OuterWrapper } from './style'

const Add = ({ onChange }) => {
  const initialFormObj = {
    userInput: ''
  }

  const form = useRef()
  const [formData, setFormData] = useState(initialFormObj)
  const [respDataMessage, setRespDataMessage] = useState({})
  // const [loader, setLoader] = useState(false)

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      userInput: formData?.userInput?.trim() || null
    }

    // INPUT VALIDATION
    // if (obj.userInput !== CONST_PASSWORD_USER_MANAGEMENT_ACCESS) {
    if (!validateLocalPassword(obj.userInput, 'userVerification')) {
      setRespDataMessage({ type: 'error', msg: 'Invalid Input!!' })
      return false
    } else {
      // userManagement.setUserNonEncryptedPasswordApi(obj)
      //   .then(resp => {
      //     // setLoader(false)
      //     setRespDataMessage({ type: 'success', msg: 'Done!!' })
      //     resetForm()
      //   })
      //   .catch(error => {
      //     setRespDataMessage({ type: 'error', msg: 'Operation Failed. Please contact administrator for assistance.' })
      //     consoleLog('ERROR : ', error)
      //     // setLoader(false)
      //   })

      setRespDataMessage({ type: 'success', msg: '' })

      setTimeout(() => {
        onChange(obj)
        resetForm()
      }, 2000)
    }
  }

  const resetForm = () => {
    setFormData(initialFormObj)
  }

  return (
    <AccordionWithArrow title='User Verification' accordionstyle='fieldset' showArrow={false}>
      <OuterWrapper>
        <form ref={form} onSubmit={submitPayload} autoComplete='on'>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ justifyContent: 'left', display: 'flex' }}>
              <MuiTextField
                name='userInput'
                placeholder='Enter Password'
                label='Password'
                onChange={(e) => onChangeHandler('userInput', e.target.value)}
                variant='standard'
                style={{ width: '250px' }}
                value={formData?.userInput || ''}
                type='password'
              />
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginLeft: '20px' }}
              >
                Submit
              </MuiButton>
            </Grid>
            <Grid item xs={12}>
              <Message type={respDataMessage?.type} align='left'>{respDataMessage?.msg || ''}</Message>
            </Grid>
          </Grid>
        </form>
      </OuterWrapper>
    </AccordionWithArrow>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
